import { QuestionnaireModel } from "../../../models/QuestionnaireModel";
import { getDefaultLanguage } from "../../../models/utilities/questionnaireUtilities";
import { ActionTypes } from "../../actions/types";
import { CHANGE_LANGUAGE, QUESTIONNAIRE_CHANGED, RESPONDENT_CHANGED } from "../../actions";

export const languageSliceReducer = (
    state: string,
    action: ActionTypes,
    questionnaire: QuestionnaireModel,
) => {
    switch (action.type) {
        case CHANGE_LANGUAGE: {
            const lang = questionnaire.languages.some((l) => l === action.code)
                ? action.code
                : getDefaultLanguage(questionnaire);
            document.documentElement.lang = lang;
            return lang;
        }
        case QUESTIONNAIRE_CHANGED:
            return questionnaire.defaultLanguage;
        case RESPONDENT_CHANGED:
            if (action.respondent.language) return action.respondent.language;
            return state;
        default:
            return state;
    }
};
